import React, { Component } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'

import sortBy from 'lodash/sortBy'

import PacePrintPV from './PacePrintPV'
import AuthA from '../../store/actions/AuthA'
import { resolveGradingScheme } from '../../utils/gradingScheme'

const _ = { sortBy }

/**
 * Loads everything the printed PACE form needs for one learner: the whole
 * competency list for their grade level across all subjects, and every rating
 * they have across all three terms.
 *
 * The form is a year-long record, so unlike the entry grid this is not scoped
 * to a term or a subject.
 */
class PacePrintPC extends Component {
  state = {
    sectionStudent: null,
    section: null,
    schoolYear: null,
    competencies: [],
    ratings: {},   // `${competencyId}|${macroSkill}|${term}` -> 'A'..'E'
    loading: true,
    error: null,
  }

  componentDidMount() {
    // This page is reached by a direct link from the card and the entry grid,
    // which is a full page load with an empty store.
    this.props.authFn.getToken()

    this.load()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.sectionStudentId !== this.props.match.params.sectionStudentId) {
      this.load()
    }
  }

  api(path) {
    return process.env.REACT_APP_URL + path
  }

  load() {
    const { sectionStudentId } = this.props.match.params
    this.setState({ loading: true, error: null })

    const url = this.api(
      '/sectionStudents?filter[where][sectionStudentId]=' + sectionStudentId +
      '&filter[include]=student&filter[include]=section')

    axios.get(url)
      .then((response) => {
        const sectionStudent = response.data[0]
        if (!sectionStudent) {
          return this.setState({ loading: false, error: 'This learner could not be found.' })
        }
        const section = sectionStudent.section

        return axios.get(this.api('/schoolYears/' + section.schoolYearId))
          .then((syResponse) => {
            this.setState({ sectionStudent, section, schoolYear: syResponse.data })
            return Promise.all([
              this.loadCompetencies(section.gradeLevel),
              this.loadRatings(sectionStudentId),
            ])
          })
          .then(() => this.setState({ loading: false }))
      })
      .catch(() => this.setState({
        loading: false,
        error: 'Could not load the PACE form. Please refresh and try again.',
      }))
  }

  loadCompetencies(gradeLevel) {
    const url = this.api(
      '/competencies?filter[where][active]=true' +
      '&filter[where][gradeLevel]=' + encodeURIComponent(gradeLevel) +
      '&filter[order]=sortOrder ASC')

    return axios.get(url).then((response) => {
      this.setState({ competencies: _.sortBy(response.data, 'sortOrder') })
    })
  }

  loadRatings(sectionStudentId) {
    const url = this.api(
      '/competencyRatings?filter[where][active]=true' +
      '&filter[where][sectionStudentId]=' + sectionStudentId)

    return axios.get(url).then((response) => {
      const ratings = {}
      response.data.forEach((r) => {
        ratings[`${r.competencyId}|${r.macroSkill || ''}|${r.term}`] = r.rating
      })
      this.setState({ ratings })
    })
  }

  get scheme() {
    const { section, schoolYear } = this.state
    if (!section || !schoolYear) return null
    return resolveGradingScheme(schoolYear, section.gradeLevel, {
      levelType: section.levelType,
    })
  }

  render() {
    return (
      <PacePrintPV
        {...this.state}
        auth={this.props.auth}
        scheme={this.scheme}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.AuthR.auth,
  userType: state.AuthR.userType,
})

const mapDispatchToProps = (dispatch) => ({
  authFn: AuthA(dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(PacePrintPC)
